import React from "react";
import dagdushethImg from '../assets/images/dagdusheth.png';

const UpComingEvent = () => {
  return (
    <div>
      <h1>Upcoming Events</h1>
    </div>
  );
};


export default UpComingEvent;